import React, { Component } from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { CSVLink, CSVDownload } from "react-csv";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import tableRequest from "../../models/tableRequest";
import DemappingReportService from "../../services/DemappingReportService.js";
// import MessageComponent from '../../template/Message';
import $ from "jquery";
import { BreadCrumb } from "primereact/breadcrumb";
import { Card } from "primereact/card";
import { toast, ToastContainer } from "react-toastify";
import { Dropdown } from "primereact/dropdown";

export default class DemappingReport extends Component {
  constructor(props) {
    super(props);
    this.surveyLink = React.createRef();
    this.DemappingReportService = new DemappingReportService();
    this.tblResponse = new tableRequest();
    this.state = {
      FromDate: new Date(),
      ToDate: new Date(),
      success: false,
      visible: false,
      sortOrder: "",
      sales: [],
      loading: true,
      first: 0,
      rows: 10,
      totalRecords: 0,
      globalFilter: null,
      updateLoader: false,
      emptyMessage: "No Data found",
      allData: [],
      BatchCode: "",
      batchCodeOptions: [],
    };
    this.onPage = this.onPage.bind(this);
    this.FilterData = this.FilterData.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.GetDemappingExport = this.GetDemappingExport.bind(this);

    this.onSort = this.onSort.bind(this);
    //this.setPreprintedValue = this.setPreprintedValue.bind(this);
  }

  //to trigger api function on page call
  componentDidMount() {
    setTimeout(() => {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      this.tblResponse.FromDate = this.toMMDDYYYY(date);
      this.tblResponse.ToDate = this.toMMDDYYYY(new Date());
      this.setState({
        FromDate: date,
        ToDate: new Date(),
      });

      this.GetDemapping();
    }, 1000);
  }

  toMMDDYYYY(date) {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }

  //to search
  searchFilter(e) {
    this.setState({ loading: true });
    this.tblResponse.SearchValue = e.target.value;
    this.GetDemapping();
  }

  onChange = (date) => this.setState({ FromDate: "", ToDate: "" });
  //on page loading
  onPage(event) {
    this.setState({
      loading: true,
    });

    //imitate delay of a backend call
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetDemapping();
    }, 250);
  }

  // get data list from api
  GetDemappingExport() {
    this.DemappingReportService.GetDemappingReportEX(this.tblResponse).then(
      (data) => {
        const resdata = data.data;
        //if response data not null
        if (
          resdata !== null &&
          resdata.ResponseData !== null &&
          resdata.ResponseData.length > 0
        ) {
          resdata.ResponseData.forEach(function (v) {
            delete v.TotalRows;
            delete v.IsDemapped;
            delete v.ProductImg;
            delete v.fakeVerify;
          });

          this.setState({
            allData: resdata.ResponseData,
          });
          this.setState({ allData: resdata.ResponseData }, () => {
            this.surveyLink.link.click();
          });

          // if (resdata.ResponseData !== null) {

          // }
        }
      },
    );
  }
  //to handle
  //resolved KREP-22

  handleChange(event) {
    const { name, value } = event.target;

    // ? BATCH FILTER LOGIC
    if (name === "BatchCode") {
      this.setState({ BatchCode: value, loading: true }, () => {
        this.tblResponse.SearchValue = ""; // optional
        this.tblResponse.BatchCode = value || ""; // ? PASS REAL VALUE

        this.tblResponse.FromDate = this.toMMDDYYYY(this.state.FromDate);
        this.tblResponse.ToDate = this.toMMDDYYYY(this.state.ToDate);
        this.tblResponse.First = 1;
        this.tblResponse.PageSize = this.state.rows;
        this.tblResponse.SortColumn = "DemappingDate";
        this.tblResponse.SortOrder = "DESC";

        this.setState({ first: 0 });

        this.GetDemapping();
      });
      return;
    }

    //to validate each form field with required conditions
    switch (name) {
      case "FromDate":
        if (value == null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select from date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (value instanceof Date && this.state.ToDate instanceof Date) {
          const startDate = value;
          const endDate = this.state.ToDate;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("From date must be less than to date.");
            return;
          }
        }

        break;
      case "ToDate":
        if (value == null || !(value instanceof Date)) {
          this.formIsValid = false;
          toast.error("Please select to date.");
          return;
        } else if (
          !value.toLocaleDateString().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/)
        ) {
          this.formIsValid = false;
          toast.error("Please enter only date.");
          return;
        } else if (
          value instanceof Date &&
          this.state.FromDate instanceof Date
        ) {
          const startDate = this.state.FromDate;
          const endDate = value;
          if (!(Date.parse(startDate) <= Date.parse(endDate))) {
            this.formIsValid = false;
            toast.error("To date must be greater than from date.");
            return;
          }
        }
        break;
      default:
        break;
    }

    this.setState({ [name]: value }, () => {
      if (name === "FromDate" || name === "ToDate") {
        this.tblResponse.FromDate = this.toMMDDYYYY(this.state.FromDate);
        this.tblResponse.ToDate = this.toMMDDYYYY(this.state.ToDate);
      }
    });
  }
  //to filter data
  FilterData() {
    this.setState({ loading: true, first: 0 });

    this.tblResponse.FromDate = this.toMMDDYYYY(this.state.FromDate);
    this.tblResponse.ToDate = this.toMMDDYYYY(this.state.ToDate);
    this.tblResponse.First = 1; // reset to first page
    this.tblResponse.PageSize = this.state.rows;

    this.GetDemapping();
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    this.tblResponse.FromDate = this.toMMDDYYYY(this.state.FromDate);
    this.tblResponse.ToDate = this.toMMDDYYYY(this.state.ToDate);
    this.GetDemapping();
  }

  // get data list from api

GetDemapping() {
  this.tblResponse.SortColumn = "DemappingDate";
  this.tblResponse.SortOrder = "DESC";

  this.DemappingReportService.GetDemappingReport(this.tblResponse)
    .then((data) => {
      const resdata = data.data;
      this.setState({ updateLoader: true });

      if (resdata?.ResponseData?.length > 0) {
        this.datasource = resdata.ResponseData;

        const uniqueBatchCodes = [
          ...new Set(
            this.datasource
              .map((item) => item.BatchCode)
              .filter((code) => code && String(code).trim() !== "")
              .map((code) => String(code).trim()),
          ),
        ];

        const batchOptions = uniqueBatchCodes.map((code) => ({
          value: code,
          label: code,
        }));

        const selectedBatch = this.state.BatchCode;
        const selectedExists = batchOptions.some(
          (x) => x.value === selectedBatch,
        );

        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource,
          batchCodeOptions: batchOptions,
          BatchCode: selectedExists ? selectedBatch : "",
          loading: false,
        });
      } else {
        this.datasource = [];
        this.setState({
          totalRecords: 0,
          sales: [],
          batchCodeOptions: [],
          BatchCode: "",
          loading: false,
        });
      }
    })
    .catch(() => {
      this.datasource = [];
      this.setState({
        totalRecords: 0,
        sales: [],
        batchCodeOptions: [],
        BatchCode: "",
        loading: false,
      });
    });
}

  //to sort
  onSort(event) {
    // Toggle sort order
    const newSortOrder = event.sortOrder === 1 ? "ASC" : "DESC";

    // Determine the column to sort by
    let sortField = event.sortField ? event.sortField : "CreatedDate";
    if (sortField === "CreatedDate") sortField = "CreatedDt";

    // Update request object
    this.tblResponse.SortColumn = sortField;
    this.tblResponse.SortOrder = newSortOrder;

    // Update state for UI
    this.setState({ sortOrder: newSortOrder });

    // Fetch sorted data from API
    this.GetDemapping();
  }

  /// to set isPreprinted
  // setPreprintedValue(e) {

  //     this.setState({
  //         isPreprintedValue: e.value,
  //         isPreprinted: e.value == "Static Qr Demapping" ? false : true
  //     }, () => {
  //         this.tblResponse.isPreprinted = this.state.isPreprinted;
  //         this.GetDemapping();
  //     });

  // }

  formatDate = (row) => {
    if (!row.CreatedDate) return "";

    const d = new Date(row.CreatedDate);

    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();

    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");

    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
  };

  //to render html part
  render() {
    const items = [{ label: "Masters" }, { label: "Demapping Report" }];
    const home = { icon: "pi pi-home", url: "/dashboard" };
    const options = ["Static Qr Demapping"]; //, 'PrePrinted Qr Demapping'];
    let header = (
      <div className="row">
        <div className="col-md-8">
          {/* <form className="form-inline">
            <div className="form-group mr-2">
              <Calendar
                value={this.state.FromDate}
                name="FromDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="From Date"
              />
            </div>
            <div className="form-group">
              <Calendar
                value={this.state.ToDate}
                name="ToDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="To Date"
              />
            </div>
            <div className="form-group mr-2" style={{ minWidth: "200px" }}>
              <Dropdown
                value={this.state.BatchCode}
                options={this.state.batchCodeOptions}
                onChange={(e) =>
                  this.handleChange({
                    target: { name: "BatchCode", value: e.value },
                  })
                }
                optionLabel="label"
                optionValue="value"
                placeholder="Search Batch"
                filter
                showClear
                className="w-100"
                style={{ height: "38px" }}
              />
            </div>

            <button
              type="button"
              onClick={this.FilterData}
              className="btn btn-primary ml-3"
            >
              Submit
            </button>
          </form> */}

          <form className="form-inline">
            <div className="form-group mr-2">
              <Calendar
                value={this.state.FromDate}
                name="FromDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="From Date"
              />
            </div>
            <div className="form-group">
              <Calendar
                value={this.state.ToDate}
                name="ToDate"
                onChange={this.handleChange}
                appendTo={document.getElementById("root")}
                placeholder="To Date"
              />
            </div>
            <button
              type="button"
              onClick={this.FilterData}
              className="btn btn-primary ml-3"
            >
              Submit
            </button>
            <div className="form-group mr-3">
              {" "}
              <span> </span>
            </div>
            <div className="form-group mr-2" style={{ minWidth: "200px" }}>
              <Dropdown
                value={this.state.BatchCode}
                options={this.state.batchCodeOptions}
                onChange={(e) =>
                  this.handleChange({
                    target: { name: "BatchCode", value: e.value },
                  })
                }
                optionLabel="label"
                optionValue="value"
                placeholder="Search Batch"
                filter
                showClear
                className="w-100"
                style={{ height: "38px" }}
              />
            </div>
          </form>
        </div>
        <div className="text-right col-md-4">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText
            type="search"
            onInput={this.searchFilter}
            placeholder="Global Search"
            size="22"
          />
          <button
            className="btn btn-primary ml-2 mb-1 export-disabled"
            target="_blank"
            onClick={this.GetDemappingExport}
          >
            Export
          </button>
          <CSVLink
            hidden={true}
            data={this.state.allData}
            ref={(r) => (this.surveyLink = r)}
            filename={"Demapping report.csv"}
          >
            Export
          </CSVLink>
        </div>
      </div>
    );
    return (
      <>
        {/* <MessageComponent ref="Messchild" /> */}
        {/* {<Loaders loader={this.state.updateLoader} /> } */}

        <Card className="mt5">
          <div className="row">
            <div className="col-md-6 heading report">
              <h3>Demapping Report</h3>
            </div>
            <div className="col-md-6 custom-breadcrumb report">
              <BreadCrumb model={items} home={home} />
            </div>
          </div>
          <DataTable
            exportFilename="Demapping Report"
            scrollable
            responsive={true}
            header={header}
            globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage}
            value={this.state.sales}
            sortMode="multiple"
            paginator={true}
            rows={this.state.rows}
            rowsPerPageOptions={[10, 50, 200, 500]}
            totalRecords={this.state.totalRecords}
            lazy={true}
            first={this.state.first}
            onPage={this.onPage}
            onSort={this.onSort}
            ref={(el) => {
              this.dt = el;
            }}
          >
            <Column field="SeqNo" header="Seq No" sortable={true} />
            <Column field="ProductCode" header="Product" sortable={true} />
            <Column field="BatchCode" header="Batch Code" sortable={true} />
            <Column field="SupplierCode" header="Supplier" sortable={true} />
            <Column field="BarCode" header="BarCode" sortable={true} />
            <Column field="UniqueCode" header="Unique Code" sortable={true} />
            <Column field="Colour" header="Colour" sortable={true} />
            <Column
              field="DemappingDate"
              header="Demapping Date"
              body={this.formatDate}
              sortable
            />
          </DataTable>
        </Card>
      </>
    );
  }
}
